<template>
    <div class="sketch-preview">
        <div class="sketch-preview--thumbnail">
            <a v-if="download === true" :href="sketchFileDownload"
               class="btn btn--icon-inline btn--dense">
                <svg-vue icon="documents-file-search" class="icon"/>
            </a>
            <img :src="sketchFilePreview" :alt="this.$gettext('Bauteil')">
        </div>
    </div>
</template>

<script>
export default {
    name: 'SketchPreview',
    props: {
        sketchFile: Object,
        download: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        sketchFilePreview() {
            const file_informations = this?.sketchFile?.file_informations;
            return this?.sketchFile?.id ? file_informations.thumbnail ? '/sketch-file/serve/'+ this?.sketchFile?.id+'?' + Date.now() : '' : '';
        },
        sketchFileDownload() {
            return this?.sketchFile?.id ? this.$$route('sketch-file.download', {'sketchFile': this?.sketchFile?.id}) : '';
        }
    }
};
</script>
